import { LocationSearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/LocationSearchInput';
import { getCoordinateBounds } from 'libs/utils/world/worldUtils';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MinuteSearch = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    return (
        <S_MinuteSearch className={props.className}>
            <LocationSearchInput
                onLocationSelected={(params) => {
                    if (params.bounds) {
                        ctxEdit?.mapRef?.current
                            .getMap()
                            ?.fitBounds(
                                getCoordinateBounds([
                                    params.bounds.leftTop,
                                    params.bounds.rightBottom
                                ]),
                                { padding: 100, speed: 2 }
                            );
                    } else {
                        ctxEdit?.mapRef?.current.getMap()?.flyTo({
                            center: {
                                lat: params?.lat,
                                lng: params?.lng
                            },
                            zoom: 12
                        });
                    }
                }}
            />
        </S_MinuteSearch>
    );
};

const S_MinuteSearch = styled.div`
    width: 250px;
`;
